module.exports = ".green-energy ::ng-deep .main-container {\n  margin: 3em 0 0 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-products-energy-modal/alg-products-energy-modal.component.scss
// module id = ./src/app/components/dialogs/alg-products-energy-modal/alg-products-energy-modal.component.scss
// module chunks = main